import type Phaser from "phaser";
import { DEPTH } from "../objects/depthLayers.js";
import { PALETTE_NUM } from "../themes/palette.js";
import { sceneGameviewRect } from "../ui/sceneLayout.js";

export function runChapterGridTransition(scene: Phaser.Scene, rebuildGrid: () => void): void {
  const gv = sceneGameviewRect(scene);
  const cover = scene.add
    .rectangle(gv.intX, gv.intTop, gv.intW, gv.intH, PALETTE_NUM.appBackground)
    .setOrigin(0, 0)
    .setDepth(DEPTH.chapterTransitionCover)
    .setAlpha(1);
  rebuildGrid();
  scene.tweens.add({
    targets: cover,
    alpha: 0,
    duration: 160,
    ease: "Quad.easeOut",
    onComplete: () => cover.destroy(),
  });
}
